<script setup lang="ts">
import { computed, reactive, ref } from 'vue'
import { extractErrorMessages, submitLead } from '../../lib/issue_diagnosis/submit'

const props = defineProps<{
  token: string
}>()

const emit = defineEmits<{ submitted: [reportUrl: string] }>()

const lead = reactive({ companyName: '', name: '', email: '', phone: '', privacyAgreed: false })
const submitting = ref(false)
const errors = ref<string[]>([])

const canSubmit = computed(
  () =>
    !!props.token &&
    lead.companyName.trim() !== '' &&
    lead.name.trim() !== '' &&
    lead.email.trim() !== '' &&
    lead.privacyAgreed
)

async function handleSubmit() {
  if (!canSubmit.value || submitting.value) return
  submitting.value = true
  errors.value = []
  try {
    const { report_url } = await submitLead(props.token, lead)
    emit('submitted', report_url)
  } catch (e) {
    errors.value = extractErrorMessages(e)
  } finally {
    submitting.value = false
  }
}
</script>

<template>
  <div class="issue_diagnosis_lead_gate">
    <p class="issue_diagnosis_lead_gate_title">診断が完了しました</p>
    <p class="issue_diagnosis_lead_gate_desc">
      下記をご入力いただくと、貴社専用の診断結果をこの画面に表示し、あわせてメールでもお送りします。
    </p>

    <p v-if="!token" class="issue_diagnosis_lead_errors">
      通信エラーが発生しました。お手数ですが最初からやり直してください。
    </p>

    <form v-else class="issue_diagnosis_lead_form" @submit.prevent="handleSubmit">
      <ul v-if="errors.length" class="issue_diagnosis_lead_errors">
        <li v-for="err in errors" :key="err">{{ err }}</li>
      </ul>

      <input
        v-model="lead.companyName"
        type="text"
        class="issue_diagnosis_lead_input"
        placeholder="会社名"
        autocomplete="organization"
      >
      <input
        v-model="lead.name"
        type="text"
        class="issue_diagnosis_lead_input"
        placeholder="お名前"
        autocomplete="name"
      >
      <input
        v-model="lead.email"
        type="email"
        class="issue_diagnosis_lead_input"
        placeholder="メールアドレス"
        autocomplete="email"
      >
      <input
        v-model="lead.phone"
        type="tel"
        class="issue_diagnosis_lead_input"
        placeholder="電話番号（任意）"
        autocomplete="tel"
      >
      <label class="issue_diagnosis_lead_privacy">
        <input v-model="lead.privacyAgreed" type="checkbox">
        プライバシーポリシーに同意する
      </label>

      <button type="submit" class="issue_diagnosis_cta_primary" :disabled="!canSubmit || submitting">
        {{ submitting ? '送信中…' : '診断結果を見る' }}
      </button>
    </form>
  </div>
</template>
